import { render } from "./MarkAsReadIcon.vue?vue&type=template&id=264e9674"
import script from "./MarkAsReadIcon.vue?vue&type=script&lang=js"
export * from "./MarkAsReadIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__